import WizardStepPage from './WizardStepPage';

/** Step — Merchant allocations (after Departures) */
const AllocationsStep = (props) => (
    <WizardStepPage
        stepKey="allocations"
        isStepDataLoading={props.isStepDataLoading}
        formData={props.formData?.allocations}
        onChange={props.onChange}
        errors={props.errors}
        setErrors={props.setErrors}
        tripCurrency={props.tripCurrency}
        lookupOptions={props.lookupOptions}
        itemDefaults={props.allocationItemDefaults}
    />
);

export default AllocationsStep;
